export default {
  primary: '#0275d8',
  success: '#28a745',
  danger: '#f74a55',
  warning: '#DD6B55'
}
